export default function formatMoney(number, unit = '$') {
  if (number === null || number === undefined) number = 0;
  // Elimina todo lo que no sea dígito
  let clean = String(number).replace(/[^0-9]/g, '');
  if (!clean) clean = '0';
  // Formatea con puntos de miles
  let formatted = parseInt(clean, 10).toLocaleString('es-CL');
  return `${unit}${formatted}`;
}

export function unformatMoney(string) {
  return Number.isNaN(parseInt(String(string).replace(/[^0-9]/g, '')))
    ? 0
    : parseInt(String(string).replace(/[^0-9]/g, ''));
}
